export default "__VITE_ASSET__e60ace91__"